import * as React from 'react';
import { VideoModelProp } from '../../Models/Video.interface';

import {Link} from 'react-router-dom'
import "./VideoDetails.css";
import { Button } from '../Buttons/Button';
import { FaPlus, FaShare, FaThumbsDown, FaThumbsUp } from 'react-icons/fa';
import { MyListButton } from '../Buttons/MyListButton';
import { DetailsButton } from '../Buttons/DetailsButtons';

type VideoDetailProps = {
    video: VideoModelProp
}
export const VideoDetails = (props: VideoDetailProps) => {
    const { video } = props

    return(
        <div className={"video-detail-container"}>
            <div className="video-detail-title-stack">
                <h3>{video?.name}</h3>
                <div className="video-detail-pnc">
                    <Link to={`/program/named/${video?.program_name}`}>
                        <span className="video-detail-program-link">
                            {video?.program_name}
                        </span>
                    </Link>
                    <span> | </span>
                    <span>{video?.air_date}</span>
                </div>
            </div>
 
            <div className="video-detail-action-buttons">
                <DetailsButton 
                    icon={<FaThumbsUp/>}
                    widehide
                    title={"Like"}
                />
                <DetailsButton 
                    icon={<FaThumbsDown/>}
                    widehide
                    title={"Dislike"}
                />
                <DetailsButton 
                    icon={<FaShare/>}
                    title={"Share"}
                />      
                <DetailsButton 
                    icon={<FaPlus/>}
                    title={"My List"}
                />    
            </div>

        </div>
    )
}